<template>
  <div
    :class="[
      'UIModalContent',
      { 'UIModalContent--no-bottom-padding': noBottomPadding },
    ]"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
defineProps({
  noBottomPadding: { type: Boolean, default: false },
})
</script>

<style scoped lang="scss">
.UIModalContent {
  @include font-size-14px;
  @include customScrollbar;
  font-weight: 500;
  padding: var(--padding-content, 0rem 1.5rem 1rem);
  overflow-y: auto;
  height: 100%;
  word-break: break-word;
}
</style>
